import React, { useEffect } from 'react';
import { initMetaPixel } from './lib/metaPixel';
import { StickyTopBar } from './components/StickyTopBar';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { Testimonials } from './components/Testimonials';
import { PainSection } from './components/PainSection';
import { ProductIntro } from './components/ProductIntro';
import { WhatYouReceive } from './components/WhatYouReceive';
import { BonusSection } from './components/BonusSection';
import { UrgencySection } from './components/UrgencySection';
import { Pricing } from './components/Pricing';
import { MegapackHighlight } from './components/MegapackHighlight';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
// Static data — defined at module scope so they are not re-created on every render
const FIRST_TESTIMONIALS = [{
  initials: 'MV',
  quote: 'Organicé todo el año de Física en una tarde. Nunca pensé que fuera posible.',
  name: 'MV — MARCELA V.',
  location: 'CÓRDOBA | FÍS. Y QUÍMICA'
}, {
  initials: 'JP',
  quote: 'Mis alumnos de 4to año por fin hacen los ejercicios sin quejarse. El material engancha.',
  name: 'JP — JOAQUÍN P.',
  location: 'ROSARIO | FÍSICA Y QUÍMICA'
}, {
  initials: 'SC',
  quote: 'Nunca más llegué al aula sin saber qué dar. Esto me cambió el año.',
  name: 'SC — SILVIA C.',
  location: 'BUENOS AIRES | FÍSICO-QUÍMICA'
}];
const MORE_TESTIMONIALS = [{
  initials: 'MV',
  quote: 'Compré el Pack un domingo a la noche. El lunes tenía todo organizado por nivel y materia. Las actividades están pensadas para que los chicos realmente aprendan, no para llenar el tiempo de clase.',
  name: 'Marcela V.',
  location: '📍 Córdoba | Docente de Físico-Química'
}, {
  initials: 'CR',
  quote: 'Empecé con el pack de FQ y a los 3 días compré el Megapack. Doy clases en 3 cursos distintos y no podía trabajar con la mitad. Los bonus de gestión me cambiaron la vida.',
  name: 'Carlos R.',
  location: '📍 Mendoza | Físico-Química y Física'
}, {
  initials: 'SM',
  quote: 'Lo que más valoro es que está organizado POR NIVEL Y MATERIA. No tengo que adivinar qué le corresponde a cada curso. Todo ya está pensado y secuenciado.',
  name: 'Sandra M.',
  location: '📍 Buenos Aires | Docente de Química'
}, {
  initials: 'FL',
  quote: 'Tenía miedo de que fuera material genérico. Pero desde la primera clase noté que está pensado para el aula real, para docentes que tienen 35 chicos y poco tiempo de preparación.',
  name: 'Fernanda L.',
  location: '📍 Tucumán | Docente de Física'
}, {
  initials: 'JP',
  quote: 'Mis alumnos de 4to año por fin hacen los problemas sin protestar. Los ejercicios son modernos, no de los libros de los 90. Se acabó la pregunta: ¿para qué aprendemos esto?',
  name: 'Joaquín P.',
  location: '📍 Rosario | Docente de Física'
}, {
  initials: 'VT',
  quote: 'Entregué los proyectos de ESI y EAI el primer día. Mi directora me preguntó cómo los tenía tan completos. Ni le conté que tardé 10 minutos en personalizarlos.',
  name: 'Valeria T.',
  location: '📍 Santa Fe | Docente de Físico-Química'
}];
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <main className="w-full min-h-screen bg-white" data-id="element-0">
      <StickyTopBar data-id="element-1" />
      <Hero data-id="element-2" />
      <SocialProofBar data-id="element-3" />

      <section className="bg-gray-100 py-12 md:py-16 px-4" data-id="element-4">
        <div className="max-w-5xl mx-auto" data-id="element-5">
          <Testimonials testimonials={FIRST_TESTIMONIALS} columns={3} showStars data-id="element-6" />
        </div>
      </section>

      <PainSection data-id="element-7" />
      <ProductIntro data-id="element-8" />
      <WhatYouReceive data-id="element-9" />
      <BonusSection data-id="element-10" />
      <UrgencySection data-id="element-11" />
      <Pricing data-id="element-12" />
      <MegapackHighlight data-id="element-13" />

      <section className="bg-white py-12 md:py-16 px-4" data-id="element-14">
        <div className="max-w-5xl mx-auto" data-id="element-15">
          <h2 className="text-2xl md:text-3xl font-bold text-carbon text-center mb-4" data-id="element-16">
            Lo que dicen los docentes que ya tienen su Pack:
          </h2>
          <p className="text-center text-sci-orange font-semibold mb-10" data-id="element-17">
            +800 docentes de Argentina ya lo usan
          </p>
          <Testimonials testimonials={MORE_TESTIMONIALS} columns={2} showStars data-id="element-18" />
        </div>
      </section>

      <Guarantee data-id="element-19" />
      <FAQ data-id="element-20" />
      <FinalCTA data-id="element-21" />
      <Footer data-id="element-22" />
      <PurchasePopup data-id="element-23" />
    </main>;
}